"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function listFormat(list) {
    if (list instanceof Array) {
        return JSON.stringify(list);
    }
    else {
        return list;
    }
}
exports.default = listFormat;
